import React from 'react';
import {
    InputGroup, FormControl, Container, Button, Alert,
} from 'react-bootstrap';
import Connector from '../database/Connector'
import Getter from '../database/Getter'

import './Home.css'
import ToolBar from '../components/ToolBar';
import Columns from '../components/Columns'; 
const preloadProjectsObject = require('../database/PreloadProjectsObject.json');

/**
 * Shows projects according to the search or favorite list
 */
class Home extends React.PureComponent {
    constructor(props) {
        super(props);
        if (parseInt(process.env.REACT_APP_PRELOAD_PROJECTS_JSON)) {
            this.state = {
                "loading": false, projects: Getter.getFromArray('winner',preloadProjectsObject), favorites: this.allStorage(), "page": 0, "nbPages": 1, "keywordSearched": "namenamename", "error": false
            }
        } else {
            this.state = { projects: null, favorites: this.allStorage(), page: 0, nbPages: 0, startAtKey: null, limit: 5 }
        }
    }

    _conn = Connector.getConnection()

    search(keyword, isPreview) {
        if (!keyword || keyword.trim().length < 4) {
            this.setState({ loading: false, projects: null, error: 'keyword very short' })
        } else {
            const me = this
            this.setState({ loading: true, projects: null, error: null }, () => {
                let page = 0
                if (this.state.keywordSearched === keyword) {
                    page = isPreview ? me.state.page - 1 : me.state.page + 1
                    if (page < 0) page = 0
                    if (page >= this.state.nbPages) page = this.state.nbPages
                }

                const user = this.props.user ||
                {
                    username: "rtELES",
                    password: "rtELESC03.141592653589"
                }

                Getter.getFromMySqlByKeyword(
                    user,
                    keyword,
                    page,
                    res => {
                        if (res.error && res.error.name === "Error") {
                            me.setState({
                                loading: false, projects: [], page: 0, nbPages: 0, keywordSearched: keyword,
                                error: res.error.message || res.error.response.data.error
                            })
                        } else {
                            me.setState({
                                loading: false, projects: res.projects, page: res.page, nbPages: res.nbPages, keywordSearched: keyword,
                                error: (res.nbPages === 0 && 'Nothing to show you')
                            })
                        }
                    })
            }
            )
        }
    }



    allStorage() {
        function isValidProjectKey(key) {
            //41da88e0-
            return key[8] === '-';
        }
        var values = [],
            keys = Object.keys(localStorage),
            i = keys.length;

        while (i--) {
            const key = keys[i];
            //key is a valid project id?
            if (isValidProjectKey(key)) {
                const project = JSON.parse(localStorage.getItem(key));
                if (project.id) {
                    values.push(project);
                }
            }
        }

        return values;
    }

    favoriteProjectClick() {
        const all = this.allStorage()
        this.setState({ favorites: all });
    }

    favoriteToolBarItemClick(isFav) {
        this.setState({ favorites: this.allStorage(), favoriteView: isFav });
    }

    render() {
        const projects = this.state.favoriteView ? this.state.favorites : this.state.projects;

        const user = this.props.user;

        return (
            <Container className="home">
                <div className="home-header">
                    <div key='1a'>
                        <div className='subtitle enfasys'>Start point for new NASA Space Apps projects</div>
                    </div>
                    <InputGroup size='md'>
                        <FormControl aria-label="Small" aria-describedby="inputGroup-sizing-sm"
                            placeholder='Enter your keyword here'
                            onChange={e => this.setState({ keyword: e.target.value, page: 0 })}
                            onKeyPress={(e) => { if (e.charCode === 13) this.search(this.state.keyword) }} />
                        <InputGroup.Append>
                            <Button className="btn btn-primary"
                                onClick={(e) => { this.search(this.state.keyword) }}>
                                search
                                            {this.state.loading &&
                                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>

                    <div className='subtitle'>
                        <span >More than </span>
                        <span className='enfasys'>8k </span>
                        <span>projects between 2013 and 2018. <a rel="noopener noreferrer" className='mywebsite' href='https://open.nasa.gov/data-stories/the-resource-telescope/' target='_blank'>Project</a> created by
                        <a rel="noopener noreferrer" className='mywebsite' href='https://alexandrebelloni.com' target='_blank'>Alex</a>
                        </span>
                    </div>

                    <div key='pag' style={{ marginTop: '20px' }}>
                        {this.state.loading &&
                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}

                        {this.state.error &&
                            <Alert variant='danger'>
                                {this.state.error}
                            </Alert>
                        }
                    </div>
                </div>
                <ToolBar click={e => this.favoriteToolBarItemClick(e)} />
                <Columns user={user} projects={projects} favorites={this.state.favorites} favoriteClick={()=>{this.favoriteProjectClick()}} />

            </Container>
        );
    }


}

export default Home;
